export default __webpack_public_path__ + "static/media/OnTime.d5ee0a0f.png";